/**
 * Nanny B's Bakery — official Uber Eats storefront (delivery).
 * Store-specific link with diningMode=DELIVERY; opens the correct location in Barrie.
 * If the store URL ever changes in Uber Eats Manager, update this constant (and redeploy).
 */
export const UBER_EATS_STORE_URL =
  'https://www.ubereats.com/ca/store/nanny-bs-bakery-62-commerce-park-dr/ZB6i_8NsU32n2zw2sOE3yg?diningMode=DELIVERY';
